<template>
    <section>
        <div v-for="(event, index) in upcomingEvents" :key="event.id">
            <MoleculeCardEvent :class="{ '!border-b-0': index + 1 !== upcomingEvents.length }" :event="event"/>
        </div>

        <div class="my-16" v-if="upcomingEvents.length">
            <AtomButtonExplore :to="{ name: 'event.index' }" />
        </div>
    </section>
</template>

<script>
import AtomSectionSeparator from "../../global/atoms/AtomSectionSeparator.vue";
import MoleculeCardEvent from "../../event/molecules/MoleculeCardEvent.vue";
import {mapActions, mapGetters, mapState} from "vuex";
import AtomButtonExplore from "../../global/atoms/AtomButtonExplore.vue";

export default {
    name: 'OrganismHomeEvents',
    components: {AtomButtonExplore, MoleculeCardEvent, AtomSectionSeparator},
    methods: {
        ...mapActions('event', {
            getEvents: 'getEvents'
        }),
    },
    computed: {
        ...mapGetters('event', {
            upcomingEvents: 'upcomingEvents'
        }),
        ...mapState('event', {
            events: 'events'
        }),
    },
    mounted() {
        if (this.events.length === 0)
            this.getEvents({page: this.page}).then(() => this.load = false)
    }
}
</script>
